import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-title-head',
	templateUrl: './title-head.component.html'
})
export class TitleHeadComponent implements OnInit {
	@Input() module: string;
	@Input() component: string;
	@Input() bandeja;
	constructor() { }

	ngOnInit(): void {
	}

}
